import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'Online Emission and Effluent Monitoring System';

  ngOnInit() {
    // Disable right click
    // document.addEventListener('contextmenu', (event) => event.preventDefault());

    // Disable autocomplete
    setTimeout(() => {
      document.querySelectorAll('input').forEach(input => {
        input.setAttribute('autocomplete', 'off');
        input.setAttribute('autocorrect', 'off');
        input.setAttribute('spellcheck', 'false');
      });
    }, 100);
  }
}
